/**
 * TEMPORÁRIO: quando `true`, o OWNER precisa conectar a própria conta YouTube antes de criar/continuar
 * uma transmissão e não escolhe outra conta no diálogo de criação. Quando `false`, ele pode usar outra
 * conta. Precisa bater com `meulance.owner.youtube.allow-other-account` no camera-meulance
 * (application.properties): `true` aqui exige `allow-other-account=false` lá, e vice-versa.
 */
export const OWNER_YOUTUBE_CONNECTION_REQUIRED = true;
